import { Box, Divider, TextField } from "@mui/material";
import { Intervention } from "./ReadOnlyInterventionsContainer";

function ReadOnlyIntervention({
  intervention,
}: {
  intervention: Intervention;
}) {
  const { action, ecosystem } = intervention;

  const formatValuesToBeCommaSeparated = (
    values: string | Array<string> | null | undefined,
  ): string => {
    if (Array.isArray(values)) {
      const filteredValues = values.filter((value): value is string =>
        Boolean(value?.trim()),
      );
      return filteredValues.length > 0 ? filteredValues.join(", ") : "-";
    }
    return values?.trim() || "-";
  };

  const formattedAction = formatValuesToBeCommaSeparated(action);
  const formattedEcosystem = formatValuesToBeCommaSeparated(ecosystem);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <TextField
          value={formattedAction || "-"}
          variant="standard"
          id={`intervention-action-${action}-id`}
          label="Action"
          size="small"
          fullWidth
          sx={{
            marginBottom: 2,
          }}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
          }}
        />
        <TextField
          value={formattedEcosystem || "-"}
          variant="standard"
          id={`intervention-ecosystem-${ecosystem}-id`}
          label="Ecosystem"
          size="small"
          fullWidth
          sx={{
            marginBottom: 2,
          }}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
          }}
        />
      </Box>
      <Divider />
    </>
  );
}

export default ReadOnlyIntervention;
